// extracted by mini-css-extract-plugin
export default {"Box":"column-frame-module__Box__sDbkkMM","Box_1":"column-frame-module__Box_1__Nxxmq5E"};